<template>
  <div
    class="scenario-error"
    :class="{ '-false': isErrorFooter === false, '-true': isErrorFooter === true }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isErrorFooter: {
      type: Boolean,
      require: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.scenario-error {
  overflow: scroll;
  position: relative;
  transition: 0.5s;
  position: fixed;
  padding: 8px;
  text-align: left;
  background: rgba(0, 0, 0, 0.8);
  border: solid 2px #222;
  top: calc(100vh - 210px);
  color: #f8f8f8;
  display: flex;
  justify-content: flex-start;
  animation: slideIn 0.7s;
  &.-true {
    height: 136px;
  }
  &.-false {
    height: 40px;
    top: calc(100vh - 114px);
  }
}
@keyframes slideIn {
  0% {
    opacity: 0;
    transform: translateY(200px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/chatbot/cards/TranslucentCard.vue